import * as React from 'react';
import {Shop} from 'interfaces';
import DesktopNewTabAnchor from 'components/DesktopNewTabAnchor';
import {Categories} from 'components/ShopDisplay';

export interface Props {
  shop: Shop;
}

export default function ShopHeader(props: Props) {
  return (
    <div className="shop-tile__content shop-tile__content--border-bottom shop-tile__header">
      <DesktopNewTabAnchor href={`/shops/${props.shop.handle}`}>
        <p className="shop-tile__title heading--truncated">{props.shop.title}</p>
        <p className="shop-tile__url heading--truncated">
          {props.shop.isPrivate ? 'URL Hidden' : props.shop.shopDomain}
        </p>
      </DesktopNewTabAnchor>
      <Categories shop={props.shop} />
    </div>
  );
}
